import hres87uLabels from 'assets/labels/hres87u'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres87uLabels
    }
  },
  index () {
    let mockRows = []
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    let codexemp = ''
    const mockCodexemp = [ '1', '2', '3', '4', '5', '6', '7' ]
    const mockDescCodappr = {
      '1': 'Resign',
      '2': 'Period of employment',
      '3': 'Lay off',
      '4': 'Retire',
      '5': 'Fired / laid off / out as the culprit.',
      '6': 'Dead',
      '7': 'Transfer'
    }
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      codexemp = mockCodexemp[Math.floor(Math.random() * 6)]
      mockRows.push({
        id: i,
        codempid: faker.lorem.word() + ' - ',
        desc_codempid: faker.name.findName(),
        numseq: faker.random.number().toString().substr(0, 1),
        desc_codcomp: faker.name.jobTitle(),
        dtereq: moment().format('DD/MM/YYYY'),
        dteeffec: moment().format('DD/MM/YYYY'),
        desc_codexemp: mockDescCodappr[codexemp],
        staappr: '',
        status: mockStatus[staappr],
        desc_codappr: faker.name.findName(),
        dteappr: moment().format('DD/MM/YYYY'),
        remark: 'Test System',
        desc_codempap: faker.name.findName(),
        approvno: faker.random.number().toString().substr(0, 1),
        chk_appr: '',
        numexemp: '',
        flgblist: '',
        flgssm: ''
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY'),
      dteeffec: moment().format('DD/MM/YYYY'),
      codexemp: faker.finance.currencyCode() + ' - ',
      desc_codexemp: 'resign',
      desnote: 'Test System'
    }
    let mockTab2Detail = {
      codempid: faker.lorem.word() + ' - ',
      desc_codempid: faker.name.findName(),
      codpos: faker.finance.currencyCode() + ' - ',
      desc_codpos: faker.name.jobTitle(),
      intwno: faker.random.uuid(),
      numqes: '1'
    }
    let mockTab2Rows = []
    const mockTab2Total = 5
    for (var ii = 1; ii <= mockTab2Total; ii++) {
      mockTab2Rows.push({
        details: '',
        response: '',
        typeques: '',
        all_answer: ''
      })
    }
    let mockTab3Rows = []
    const mockTab3Total = 5
    for (var i = 1; i <= mockTab3Total; i++) {
      mockTab3Rows.push({
        id: i,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        codasset: faker.finance.currencyCode(),
        desc_codasset: faker.random.words(),
        qtyrcass: faker.commerce.price(),
        desc_codunit: 'Bath',
        dtercass: moment().format('DD/MM/YYYY')
      })
    }
    let mockTab4Rows = []
    const mockTab4Total = 1
    for (var a = 1; a <= mockTab4Total; a++) {
      mockTab4Rows.push({
        id: a,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        dtelonst: moment().format('DD/MM/YYYY'),
        numcont: faker.finance.currencyCode(),
        amtlon: faker.commerce.price(),
        amtnpfin: faker.commerce.price(),
        dteaccls: moment().format('DD/MM/YYYY'),
        desc_codlon: faker.finance.transactionType(),
        numlon: faker.random.number().toString().substr(0, 1)
      })
    }
    let mockTab5 = {
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      amtrepaym: faker.commerce.price(),
      qtyrepaym: faker.random.number().toString().substr(0, 1),
      dtestrpm: moment().format('DD/MM/YYYY'),
      amt: faker.commerce.price(),
      amttotpay: faker.commerce.price(),
      amtoutstd: faker.commerce.price(),
      dtelstpay: moment().format('DD/MM/YYYY')
    }
    let mockTab6Rows = []
    const mockTab6Total = 1
    for (var b = 1; b <= mockTab6Total; b++) {
      mockTab6Rows.push({
        id: b,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        desc_codsco: 'International Business Management',
        desccomm: 'Test System',
        dtestartf: moment().format('DD/MM/YYYY'),
        dtecomm: moment().format('DD/MM/YYYY')
      })
    }

    return {
      tab1: mockTab1,
      tab2: {
        detail: mockTab2Detail,
        table: {
          total: mockTab2Total,
          rows: mockTab2Rows
        }
      },
      tab3: {
        table: {
          total: mockTab3Total,
          rows: mockTab3Rows
        }
      },
      tab4: {
        table: {
          total: mockTab4Total,
          rows: mockTab4Rows
        }
      },
      tab5: mockTab5,
      tab6: {
        table: {
          total: mockTab6Total,
          rows: mockTab6Rows
        }
      }
    }
  },
  dropdowns () {
    const mockFlgssm = {
      '1': '1 - Resign',
      '2': '2 - Period of employment',
      '3': '3 - Lay off',
      '4': '4 - Retire',
      '5': '5 - Fired / laid off / out as the culprit.',
      '6': '6 - Dead',
      '7': '7 - Transfer'
    }
    const mockNumqes = {
      '1': '1.คำถามข้อที่1',
      '2': '2.คำถามข้อที่2',
      '3': '3.คำถามข้อที่3',
      '4': '4.คำถามข้อที่4'
    }

    return {
      flgssm: {
        en: mockFlgssm,
        th: mockFlgssm
      },
      numqes: {
        en: mockNumqes,
        th: mockNumqes
      }
    }
  },
  detailSubmit () {
    let mockTab1 = {
      staappr: '',
      flgStaappr: '',
      approvno: '1',
      chk_appr: '',
      numseq: '1',
      dtereq: moment().format('DD/MM/YYYY'),
      codempid: faker.lorem.word(),
      desc_codempid: faker.lorem.words(),
      codappr: faker.lorem.word(),
      desc_codappr: faker.lorem.word(),
      dteappr: moment().format('DD/MM/YYYY'),
      numexemp: '',
      flgblist: '',
      flgssm: '',
      status: faker.lorem.words(),
      remark: faker.lorem.words()
    }
    return {
      tab1: mockTab1
    }
  },
  approve () {
    return {
      codempid: faker.lorem.word() + ' - ',
      desc_codempid: faker.name.findName(),
      approvno: faker.random.number().toString().substr(0, 1),
      codappr: faker.lorem.word() + ' - ',
      desc_codappr: faker.name.findName(),
      dteappr: moment().format('DD/MM/YYYY'),
      numexemp: faker.random.number(),
      flgblist: '1',
      flgssm: faker.lorem.word(),
      staappr: '',
      status: faker.lorem.words(),
      remark: 'Test System'
    }
  },
  sendApprove () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres87u/mocker.js